import React from 'react';

import type { Text } from '@zillow/constellation';
import { FormField, Input, Label, Spacer } from '@zillow/constellation';

import type { HTMLElementEvent } from '../../../../models/Types';
import HeaderToggle from './HeaderToggle';
import type { Section } from '../../../../models/index';
import { TRASH_REMOVAL } from '../../../../constants';
import { CenteredHR } from '../../../Widgets/CenteredHR';
import YesAndNo from '../../../Widgets/YesAndNo';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

const INITIAL_STATE = {
  [TRASH_REMOVAL.FIELD_NAME.IS_ENABLED]: true,
  [TRASH_REMOVAL.FIELD_NAME.SERVICE_PROVIDER]: '',
};

export default function TrashRemoval_v2({ section, setSectionValues }: Props): JSX.Element {
  function toggleUtility(): void {
    setSectionValues({
      ...INITIAL_STATE,
      [TRASH_REMOVAL.FIELD_NAME.IS_ENABLED]: !section.getFieldValue(TRASH_REMOVAL.FIELD_NAME.IS_ENABLED),
    });
  }

  function setServiceProvider(event: HTMLElementEvent<typeof Text>): void {
    setSectionValues({
      [TRASH_REMOVAL.FIELD_NAME.SERVICE_PROVIDER]: event.currentTarget.value,
    });
  }

  function yesDeliveredToAreas(): void {
    setSectionValues({
      [TRASH_REMOVAL.FIELD_NAME.DELIVERED_TO_AREAS_OTHER_THAN_TENANTS_UNIT]: true,
    });
  }

  function noDeliveredToAreas(): void {
    setSectionValues({
      [TRASH_REMOVAL.FIELD_NAME.DELIVERED_TO_AREAS_OTHER_THAN_TENANTS_UNIT]: false,
    });
  }

  return (
    <>
      <HeaderToggle
        header="Trash removal"
        subheader="Tenant pays in addition to rent"
        switchOn={section.getFieldValue(TRASH_REMOVAL.FIELD_NAME.IS_ENABLED)}
        onSwitchToggle={toggleUtility}
      />
      {section.getFieldValue(TRASH_REMOVAL.FIELD_NAME.IS_ENABLED) && (
        <>
          <CenteredHR />
          <FormField marginBottom="sm">
            <Label id="service-provider">
              Your tenant will be responsible for cost and account set up and will pay directly to which service
              provider?
            </Label>
            <Input
              aria-labelledby="service-provider"
              value={section.getFieldValue(TRASH_REMOVAL.FIELD_NAME.SERVICE_PROVIDER)}
              onChange={setServiceProvider}
              placeholder="(example: Sunset Scavenger)"
              data-test="service-provider"
            />
          </FormField>
          <Label>Will this trash removal service be delivered to areas other than the tenant’s unit?</Label>
          <Spacer marginTop="xs" />
          <YesAndNo
            yesHandler={yesDeliveredToAreas}
            noHandler={noDeliveredToAreas}
            yesActive={section.getFieldValue(TRASH_REMOVAL.FIELD_NAME.DELIVERED_TO_AREAS_OTHER_THAN_TENANTS_UNIT)}
          />
        </>
      )}
    </>
  );
}
